import React from "react";
import "./OptionsGroup.scss";
import Button from "../../Atomsv2/Button/Button";
import Text from "../../Atomsv2/Text/Text";

const OptionsGroup = ({ options, onSelect, activeValue, label ,disabled=false,style,className}) => {
    return (
        <div className={`OptionsGroup input-field ${className}`} style={style}>
            {label && <Text size="small" color="var(--gray-dark-500)" className="input-label">{label}</Text>}
            <div className="og-buttons">
                {options.map((option, index) => (
                    <Button
                        key={index}
                        onClick={() => onSelect(option.value)}
                        className={`option-button ${activeValue === option.value ? 'option-button--active' : 'option-button--inactive'}`}
                        disabled={disabled}
                    >
                        {option.label}
                    </Button>
                ))}
            </div>
        </div>
    );
}
export default OptionsGroup;